var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "sm", withBgClickEvent: true, contentClass: "smallPadding" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { attrs: { classs: "flex justify-between flex-row" } }, [
              _c(
                "p",
                {
                  staticClass:
                    "text-base text-primary-black text-left font-semibold mb-4",
                },
                [_vm._v(" Log Hours ")]
              ),
              _c(
                "span",
                {
                  staticClass:
                    "cursor-pointer flex items-center justify-center absolute customPosition",
                  on: {
                    click: _vm.closeModal,
                    mouseover: function ($event) {
                      _vm.isHovered = true
                    },
                    mouseout: function ($event) {
                      _vm.isHovered = false
                    },
                  },
                },
                [
                  !_vm.isHovered
                    ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                    : _vm._e(),
                  _vm.isHovered
                    ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex xl:flex-wrap flex-col xl:flex-row h-auto" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col justify-flex-start items-center w-full",
                  },
                  [
                    _c("div", { staticClass: "w-full" }, [
                      _c(
                        "form",
                        {
                          staticClass: "flex flex-col justify-between",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleSubmit(_vm.saveTimeTrack)
                            },
                          },
                        },
                        [
                          _c("ValidationObserver", [
                            _c("div", { staticClass: "mb-4 flex flex-col" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col sm:flex-row w-full justify-between sm:space-x-3",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "w-full sm:w-1/2" },
                                    [
                                      _c(
                                        "FormGroup",
                                        {
                                          attrs: { errors: _vm.errors },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-2" },
                                                    [_vm._v("Start time")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                        },
                                        [
                                          _c("NewTimePicker", {
                                            attrs: {
                                              format: "HH:mm",
                                              placeholder: "Select Start Time",
                                              customControlStyle:
                                                "rightControl",
                                              "auto-scroll": "",
                                              "advanced-keyboard": "",
                                              "input-width": "100%",
                                              "input-class":
                                                "appearance-none customVisits border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "icon",
                                                fn: function () {
                                                  return [
                                                    _c("ClockIcon", {
                                                      staticClass: "w-4 h-4",
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.start_time,
                                              callback: function ($$v) {
                                                _vm.start_time = $$v
                                              },
                                              expression: "start_time",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "w-full sm:w-1/2" },
                                    [
                                      _c(
                                        "FormGroup",
                                        {
                                          attrs: { errors: _vm.errors },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-2" },
                                                    [_vm._v("End time")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                        },
                                        [
                                          _c("NewTimePicker", {
                                            attrs: {
                                              format: "HH:mm",
                                              "auto-scroll": "",
                                              invalid: _vm.failed,
                                              placeholder: "Select End Time",
                                              "advanced-keyboard": "",
                                              "input-width": "100%",
                                              customControlStyle:
                                                "rightControl",
                                              "hide-disabled-items": "",
                                              "hour-range":
                                                _vm.rangeEndHourRange,
                                              "minute-range":
                                                _vm.rangeEndMinuteRange,
                                              "second-range":
                                                _vm.rangeEndSecondRange,
                                              "input-class":
                                                "appearance-none customVisits border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "icon",
                                                fn: function () {
                                                  return [
                                                    _c("ClockIcon", {
                                                      staticClass: "w-4 h-4",
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.end_time,
                                              callback: function ($$v) {
                                                _vm.end_time = $$v
                                              },
                                              expression: "end_time",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "mb-4" }, [
                              _c("label", { staticClass: "customFormLabel" }, [
                                _vm._v(" Notes "),
                              ]),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.notes,
                                    expression: "notes",
                                  },
                                ],
                                staticClass:
                                  "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                attrs: {
                                  id: "message",
                                  rows: "4",
                                  placeholder: "Type here",
                                },
                                domProps: { value: _vm.notes },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.notes = $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _c(
                              "div",
                              { staticClass: "flex flex-row gap-4 mt-1" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "outlineTimeButton buttonHover",
                                    attrs: { processing: _vm.processing },
                                    on: { click: _vm.closeModal },
                                  },
                                  [_vm._v(" Close ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "blackTimeButton buttonHover",
                                    attrs: {
                                      disabled:
                                        !_vm.start_time ||
                                        !_vm.end_time ||
                                        _vm.end_time === "00:00:00" ||
                                        _vm.end_time === "00:00:01",
                                      processing: _vm.processing,
                                    },
                                    on: { click: _vm.saveTimeTrack },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }